import { mutationOptions } from '@tanstack/react-query';
import { toast } from 'sonner';
import { t } from '@/i18n';
import { axios } from '@/lib/utils/axios';
import type { WorkPackage } from '../../common/work-package';
import { getResponse, toastApiError } from '../common';
import { API_URLS, queryClient } from '../query.client';

export type UpdateWorkPackageSuccessResponseType = WorkPackage;

async function updateWorkPackage(
	id: string,
	payload: Omit<WorkPackage, 'id'>,
): Promise<UpdateWorkPackageSuccessResponseType | null> {
	const response = await axios.patch(`${API_URLS.WORK_PACKAGES.INDEX}/${id}`, payload);
	return getResponse<UpdateWorkPackageSuccessResponseType>(response.data);
}

export function updateWorkPackageOptions() {
	return mutationOptions({
		mutationFn: ({ id, payload }: { payload: Omit<WorkPackage, 'id'>; id: string }) => updateWorkPackage(id, payload),
		onSuccess: async (data) => {
			console.log('Work package updated successfully:', data);
			toast.success(t('finance.toast.updated'));
			await queryClient.invalidateQueries({ queryKey: ['work-packages', 'list'] });
		},
		onError: (error) => toastApiError(error),
	});
}
